import React, {useEffect, useRef, useState} from 'react';
import { useTranslation } from 'react-i18next';
import useScreenSize from "../../../../hooks/useScreenSize";
import EMDButils from "../../../../utils/emdb.utils";
import EmdbDatePicker from "../../../EmdbDatePicker";

//CSS
import styles from'./VTCalendar.module.less';

//ICON
import icon from "../../../../assets/img/calendario.png";

function VTCalendar({selecteddate, disableDays, onChange}) {
  const {t, i18n} = useTranslation("vtform");

  const calendarContentRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [seletedDate, setSeletedDate] = useState(t("vtcalendar.Seleccionar fecha"));
  const emdbUtils = new EMDButils();

  const {width} = useScreenSize();
  //const numberOfMonths = width < 630 ? 1 : 2;
  const numberOfMonths =1;

  function toggle(event) {
    if (calendarContentRef.current) {
      if (calendarContentRef.current.contains(event.target) && isOpen) return;
      setIsOpen((isOpen) => !isOpen);
    }
  }

  const handleClickOutside = (event) => {
    if (calendarContentRef.current) {
      if (calendarContentRef.current.contains(event.target)) return;
      setIsOpen(false);
    }
  };

  function handleOnChange(value) {
    onChange(value);
    setSeletedDate(emdbUtils.getDateFormat(value));
    setIsOpen(false);
  }

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      window.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div ref={calendarContentRef} className={styles.vtcalendar}  onClick={toggle}>
      <img className={styles.icon} src={icon}/>
      {seletedDate}
      {isOpen &&
        <div className={styles.calendarmodal} >
          <EmdbDatePicker
            value={selecteddate}
            onChange={(e) => handleOnChange(e)}
            disabledDays={disableDays}
            locale={i18n.language}
          />
        </div>
      }
    </div>
  );
}

export default VTCalendar;




